let pendingFetch = null

function waitForGooglePlaces(maxWaitMs = 20000, intervalMs = 50) {
  return new Promise((resolve, reject) => {
    if (typeof window === 'undefined') {
      reject(new Error('Google Maps Places no disponible'))
      return
    }

    const deadline = Date.now() + maxWaitMs
    const tick = () => {
      if (
        window.google &&
        window.google.maps &&
        window.google.maps.places
      ) {
        resolve()
        return
      }
      if (Date.now() >= deadline) {
        reject(new Error('Google Maps Places no cargado'))
        return
      }
      setTimeout(tick, intervalMs)
    }
    tick()
  })
}

const googlePlacesModule = {
  state: {
    reviews: [],
    rating: null,
    userRatingsTotal: 0,
    placesError: null,
    placeDetailsFetched: false,
    placeId: 'ChIJcfuK7UpeZg0R5I45K3PYO6o',
    fields: ['name', 'rating', 'reviews', 'user_ratings_total']
  },
  getters: {
    getGooglePlaceReviews: (state) => state.reviews,
    getGooglePlaceRating: (state) => state.rating,
    getGooglePlaceTotalReviews: (state) => state.userRatingsTotal
  },
  mutations: {
    SET_GOOGLE_PLACE_DETAILS(state, { rating, userRatingsTotal, reviews }) {
      state.rating = rating != null ? rating : null
      state.userRatingsTotal = userRatingsTotal != null ? userRatingsTotal : 0
      state.reviews = reviews || []
      state.placesError = null
      state.placeDetailsFetched = true
    },
    SET_GOOGLE_PLACE_ERROR(state, status) {
      state.placesError = status
    }
  },
  actions: {
    fetchGooglePlaceDetails({ commit, state }) {
      if (state.placeDetailsFetched) {
        return Promise.resolve()
      }
      if (pendingFetch) {
        return pendingFetch
      }

      pendingFetch = waitForGooglePlaces()
        .then(() => new Promise((resolve, reject) => {
          const service = new window.google.maps.places.PlacesService(
            document.createElement('div')
          )

          service.getDetails(
            {
              placeId: state.placeId,
              fields: state.fields
            },
            (place, status) => {
              const OK = window.google.maps.places.PlacesServiceStatus.OK
              if (status !== OK) {
                commit('SET_GOOGLE_PLACE_ERROR', status)
                reject(status)
                return
              }

              commit('SET_GOOGLE_PLACE_DETAILS', {
                rating: place.rating,
                userRatingsTotal: place.user_ratings_total,
                reviews: place.reviews || []
              })
              resolve()
            }
          )
        }))
        .finally(() => {
          pendingFetch = null
        })

      return pendingFetch
    }
  }
}

export default googlePlacesModule



// WEBPACK FOOTER //
// ./src/store/googlePlaces.js